import { action } from 'satcheljs';
import WeatherLocationType from 'owa-service/lib/contract/WeatherLocationType';

export let addToWeatherList = action('addToWeatherList', (weatherItem: WeatherLocationType) => {
    return {
        weatherItem,
    };
});
